import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { getWebPageSchema, getBreadcrumbSchema } from '@/lib/schema';

export default function DatabasePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd schema={getWebPageSchema('/database', 'Database Prodotti Itaobuy Spreadsheet', 'Esplora il database completo di prodotti verificati Itaobuy Spreadsheet con prezzi, valutazioni di qualità e aggiornamenti in tempo reale per sneakers, abbigliamento e accessori.')} />
      <JsonLd schema={getBreadcrumbSchema([{ name: 'Home', url: '/' }, { name: 'Database', url: '/database' }])} />
      <Navbar />
      <section className="w-full px-6 md:px-10 pt-28 pb-12 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <nav className="flex items-center gap-2 text-xs font-body text-foreground-500 mb-6 flex-wrap">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-xs"></i>
            </span>
            <span className="text-foreground-400 whitespace-nowrap">Database</span>
          </nav>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-4">
            Database Prodotti Itaobuy Spreadsheet
          </h1>
          <p className="font-body text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            Esplora il nostro database completo di prodotti verificati con prezzi, valutazioni di qualità e aggiornamenti in tempo reale. Questa sezione è in fase di sviluppo e sarà presto disponibile con tutte le funzionalità di ricerca e filtro.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-arrow-left-line text-sm"></i>
              Torna alla Home
            </Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 border border-primary-300 text-primary-600 font-label text-sm font-semibold rounded-full hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap">
              Vai allo Spreadsheet
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>
        </div>
      </section>
      <section className="w-full px-6 md:px-10 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {["Sneakers", "Hoodies", "T-Shirts", "Accessories", "Bags", "Jackets", "Jersey", "Headwear"].map((cat, i) => (
              <div key={i} className="bg-background-50 border border-background-200 rounded-xl p-5 text-center">
                <span className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shopping-bag-line text-accent-600 text-lg"></i>
                </span>
                <h3 className="font-label text-sm font-semibold text-foreground-800 whitespace-nowrap">{cat}</h3>
                <p className="font-body text-xs text-foreground-500 mt-1">Prossimamente</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}